<template>
  <div class="container">
		<div class="tile is-ancestor">
      <div class="tile is-parent is-vertical">
				<div class="tile is-child" v-for="(scene, ix) in currentScenes" v-bind:key="scene.name">
					<div class="card">
						<div class="card-image">
							<img v-bind:src="getImgUrl(scene.name)" alt="">
						</div>
						<div class="card-content">
							<div class="content" v-show="showText">
								{{scene.text}}
							</div>
							<div class="content" v-show="showEntry">
								<div class="field">
									<label class="label">Describe the tip the image is depicting</label>
									<div class="control">
										<input v-model="scene.guess" v-bind:disabled="scene.sent" class="input" type="text" placeholder="Guess">
									</div>
								</div>
								<div class="field">
									<p class="control">
									<button v-on:click="sendGuess(scene.name)" class="button is-info" v-bind:disabled="scene.sent">
										Send
									</button>
									</p>
								</div>
							</div>
							<div class="content" v-show="showResponses">
								<ol>
									<li v-for="msg in messagesByName[scene.name]">{{isAdministrator ? `${msg.username} - ` : ``}}{{msg.guess}}</li>
								</ol>
							</div>
							<div class="content" v-show="showAdminFocus">
								<div class="field">
									<label class="checkbox">
										<input
											v-on:change="toggleFocus(scene.name)"
											v-model="focused"
											v-bind:value="scene.name"
											type="checkbox"
											v-bind:id="scene.name"
											class="checkbox">
										Focus
									</label>
								</div>
							</div>
						</div>
					</div>
		    </div>
		  </div>
		</div>
  </div>
</template>

<script>
export default {
  name: 'Scenarios',
  props: {
		mode: String,
		message: Object,
		admin: String,
		isAdministrator: {
			type: Boolean,
			default: false
		},
		randomSet: {
			type: Number,
			default: 2
		}
  },
	data() {
		return {
			currentScene: null,
			scenes: [
				{name: 'plan', text: 'Plan ahead and give yourself sufficient time.'},
				{name: 'railing', text: 'When walking on steps, always use the hand railings and plant your feet firmly on each step.'},
				{name: 'steps', text: 'When walking on an icy or snow-covered walkway, take short steps and walk at a slower pace so you can react quickly to a change in traction.'},
				{name: 'knees', text: 'Bending your knees a little and taking slower and shorter steps increases traction and can greatly reduce your chances of falling. It also helps to stop occasionally to break momentum.'},
				{name: 'blackice', text: 'Streets and sidewalks that have been cleared of snow and ice should still be approached with caution. Look out for "black ice." Dew, fog or water vapor can freeze on cold surfaces and form an extra-thin, nearly invisible layer of ice that can look like a wet spot on the pavement. It often shows up early in the morning or in areas that are shaded from the sun.'},
				{name: 'heavy', text: 'Carrying heavy items can challenge your sense of balance. Try not to carry too much--you need to leave your hands and arms free to better balance yourself.'},
				{name: 'fall', text: 'Be prepared to fall and try to avoid using your arms to break your fall. If you fall backward, make a conscious effort to tuck your chin so your head doesn\'t strike the ground with a full force.'},
				{name: 'boots', text: 'When entering a building, remove as much snow and water from your boots as you can. Take notice that floors and stairs may be wet and slippery--walk carefully.'},
				{name: 'vehicle', text: 'Use special care when entering and exiting vehicles--use the vehicle for support.'},
			],
			messages: [],
			randomIndexes: [],
			messagesByName: {},
			focused: []
		}
	},
	methods: {
		getImgUrl( img ) {
			const images = require.context('../assets/', false, /\.png$/)
			return images('./' + img + ".png")
		},
		getScene ( name ) {
			return this.scenes.find(item => item.name === name)
		},
		getMessages( name ) {
			return this.messages.find(item => item.name === name)
		},
		sendGuess( name ) {
			const scene = this.getScene(name)
			this.$emit('message', scene)
			this.$set(scene, 'sent', true)
		},
		getRandomIndexes() {
			const arr = []
			while (arr.length < this.randomSet) {
				const r = Math.floor(Math.random() * this.scenes.length)
				if (arr.indexOf(r) === -1) arr.push(r)
			}
			return arr
		},
		toggleFocus(name) {
			const isFocused = this.focused.includes(name)
			this.focused = !isFocused ? [] : [name]
			this.$emit('focus', {name, isFocused})
		}
	},
	computed: {
		currentScenes() {
			if (this.admin) {
				return this.scenes.map(item => item).filter(item => item.name === this.admin)
			} else if (this.mode === 'random') {
				return this.scenes.map(item => item).filter((item, ix) => this.randomIndexes.includes(ix))
			} else if (this.mode === 'none') {
				return []
			} else {
				return this.scenes
			}
		},
		sceneNames() {
			return this.scenes.map(item => item.name)
		},
		showText() {
			return this.mode === 'review' || this.isAdministrator
		},
		showResponses() {
			return this.mode === 'review' || this.isAdministrator
		},
		showEntry() {
			return this.mode === 'random' && !this.isAdministrator
		},
		showAdminFocus() {
			return this.mode === 'review' && this.isAdministrator
		}
	},
	watch: {
		message(newMsg) {
			this.messages.push(newMsg)
			this.$set(this.messagesByName, newMsg.name, this.messages.filter(m => m.name === newMsg.name))
		}
	},
	created() {
		this.randomIndexes = this.getRandomIndexes()
	},
	mounted() {
		this.focused = this.scenes.map(item => false)
		this.messagesByName = this.sceneNames.reduce( (memo, item) => {
			memo[item] = this.messages.filter(m => m.name === item)
			return memo
		}, {})
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.content {
	text-align: left;
}

</style>
